<script lang="ts">
	import formatNumber from 'utils/formatNumber';

	export let value: number;
	$: impact = findValueClass(value);

	function findValueClass(value: number) {
		if (value >= 8) {
			return 'high';
		}
		if (value >= 4 && value < 8) {
			return 'medium';
		}
		if (value >= 0 && value < 4) {
			return 'low';
		}
	}
</script>

{#key impact}
	<p class={`impact-score ${impact}`}>
		{formatNumber(value, null, false, 'decimal')}
	</p>
{/key}

<style lang="scss">
	@import 'impactScore';
</style>
